import * as c from '../constants/notification';

export const modal = (title, body, buttons = [], options = {}) => {
  const validOptions = {
    bsSize: ['lg', 'large', 'sm', 'small'],
    backdrop: [true, false],
    animation: [true, false],
    allowHtml: [true, false],
    closeButton: [true, false],
    logoutOnClose: [true, false],
  };

  let goodOptions = {};
  for (let key in options) {
    if (
      validOptions.hasOwnProperty(key) &&
      validOptions[key].indexOf(options[key]) >= 0
    ) {
      goodOptions[key] = options[key];
    }
  }

  return {
    type: c.NOTIFICATION_APPEND_MODAL,
    title,
    body,
    buttons,
    ...goodOptions,
  };
};

export const toast = (message, category = 'info', options) => ({
  type: c.NOTIFICATION_APPEND_TOAST,
  message,
  category,
  ...options,
});

export const dismiss = (id) => ({
  type: c.NOTIFICATION_DISMISS,
  id,
});
